import { LocationStrategy, PlatformLocation } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
// import { ToastrService } from 'ngx-toastr/public_api';
import { fromEvent, Subscription } from 'rxjs';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { ComponentCanDeactivate } from 'src/app/components/PendingChangesGuard';
import { ProductdetailsComponent } from 'src/app/components/productdetails/productdetails.component';
import { GroupbyPipe } from 'src/app/groupby.pipe';
import { AppSettings } from 'src/app/services/constants/constants';
import { CartService } from 'src/app/services/dhukan/cart.service';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { CartsliderComponent } from '../cartslider/cartslider.component';
import { LoginComponent } from '../login/login.component';
import { OrdersComponent } from '../orders/orders.component';
import { OrdersdetailsComponent } from '../ordersdetails/ordersdetails.component';
import { OrderstatusComponent } from '../orderstatus/orderstatus.component';
import { QrproductdetailsComponent } from '../qrproductdetails/qrproductdetails.component';
import { RequestComponent } from '../request/request.component';


@Component({
  selector: 'app-qrmenu',
  templateUrl: './qrmenu.component.html',
  styleUrls: ['./qrmenu.component.css']
})
export class QrmenuComponent implements OnInit {
  dinetype: String = ""

  cartBO: any = {};
  cartColl: any = [];
  cartView: any = {};
  orderColl: any = [];

  customerBO: any = {};
  customerOrderMainColl: any = [];
  customerOrderDetailsColl: any = [];
  customerView: any = {};

  companyBO: any = {}
  groupColl: any = [];
  groupallColl: any = [];
  productColl: any = [];
  productgroupColl: any = [];
  productvariationColl: any = [];

  selectgroup: any = ""
  searchtxt: any = ""

  isshowcategory: boolean = false
  isvegonly: boolean = false
  isopensearch: boolean = false

  // _urlname: any = ""
  //productid: number = 0;

  @Input() urlname = ""
  @Input() tblname = null

  @Output() menuChanged = new EventEmitter<any>();

  routerEventSubscription = Subscription.EMPTY;
  _routerCartSub = Subscription.EMPTY;
  _routerCustomerSub = Subscription.EMPTY;
  _routerPopupSub = Subscription.EMPTY;
  subscription = Subscription.EMPTY;
  selectedGroupName: string = 'All'; 


  modalRef: NgbModalRef;
  modalRef1: NgbModalRef;

  isload: boolean = false;

  constructor(private location: LocationStrategy, private appService: DhukanDataService, private loginService: LoginDataService, public router: Router, private productFindService: NgbModal, private cartservice: CartService,
    private toastr: ToastrService, private cuurenctRoute: ActivatedRoute, private confirmationDialogService: ConfirmationDialogService,) {

    if (AppSettings.appname === "QRTAKEAWAY") {
      this.dinetype = "TAKEAWAY";
    }
    else if (AppSettings.appname === "QRDINEIN") {
      this.dinetype = "DINEIN";
    }
    else if (AppSettings.appname === "QRDELIVERY") {
      this.dinetype = "DELIVERY";
    }



    this.fnServiceChanges()

  }


  fnServiceChanges() {
    this.cartView = this.cartservice.cartView;
    this._routerCartSub = this.cartservice.servicecartChange.subscribe((value) => {
      this.cartView = value
      if (this.cartView.cartmain) {
        this.cartBO = this.cartView.cartmain
      }
      if (this.cartView.cartdetails) {
        this.cartColl = this.cartView.cartdetails
      }
      if (this.cartView.orderColl) {
        this.orderColl = this.cartView.orderColl

      }

      this.fnUpdateCartChange();
    });

    this._routerCustomerSub = this.loginService.servicecustomerChange.subscribe((value) => {
      this.customerView = value
      if (this.customerView.customermain) {
        this.customerBO = this.customerView.customermain
      }
    });

    this._routerPopupSub = this.loginService.servicemodelpopupChange.subscribe((value) => {
      if (value === true) {
        this.modalRef.close();
      }
    })

  }

  ngOnInit() {

    this.fngetProduct()

    history.pushState(null, null, location.href);

    this.subscription = fromEvent(window, 'popstate').subscribe(_ => {

      let body = document.getElementsByTagName('body')[0];
      if (body.classList.length > 0) {
        if (body.classList[0] === 'modal-open') {
          console.log('return false')
          this.modalRef.close()
          if (this.modalRef1) {
            this.modalRef1.close()
          }


          history.pushState(null, null, location.href);
        }
      }
      else if(this.isshowcategory===true)
      {
        this.isshowcategory=false;
        history.pushState(null, null, location.href);
      }
      else {
        history.back()
      }

    });
  }

  ngOnDestroy(): void {
    if (this._routerCartSub !== undefined) {
      this._routerCartSub.unsubscribe();
    }

    if (this._routerCustomerSub !== undefined) {
      this._routerCustomerSub.unsubscribe();
    }

    if (this._routerPopupSub !== undefined) {
      this._routerPopupSub.unsubscribe();
    }

    if (this.subscription !== undefined) {
      this.subscription.unsubscribe();
    }
  }


  fnGetUrlParameters() {



  }

  fngetProduct() {

    var data = {
      'urlname': this.urlname,
      'tableno': this.tblname,
      'dinetype': this.dinetype,
      'sessionid': (localStorage.session === undefined) ? '' : localStorage.session,
    }

    console.log(data)
    this.appService.getProductDetailsByQrmenu(data)
      .subscribe(
        (res) => {
          if (res.json().status == 200) {
            var result = res.json().result;
            if (result.length > 0) {
              if (result[0].length > 0) {
                this.companyBO = result[0][0]
                this.cartservice.companyBO = this.companyBO
              }
              this.groupColl = result[1];
              this.groupallColl = result[1];
              this.productColl = result[2];
              this.productvariationColl = result[3];

              this.fnReloadProductList();

              if (this.companyBO.checkstatus !== "DONE") {
                this.menuChanged.emit(3)
              }
            }

            this.cartservice.fnGetCartList();
            this.loginService.fnGetCustomerList()
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }
        },
        (err) => {

          this.toastr.error('Error', err);
        })
  }

  fnReloadProductList() {


    this.productgroupColl = [];
    this.groupColl = [];



    for (let gbo of this.groupallColl) {
      let tempColl = []

      for (var pbo of this.productColl) {
        if (pbo.groupid === gbo.groupid) {
          if (this.isvegonly === true && pbo.foodsymbol === 'VEG') {
            tempColl.push(pbo);
          }
          else if (this.isvegonly === false) {
            tempColl.push(pbo);
          }
        }
      }


      var abo = {
        groupid: gbo.groupid,
        groupname: gbo.groupname,
        productColl: tempColl
      }

      if (tempColl.length > 0) {
        this.productgroupColl.push(abo)
      }
    }

    for (var pbo of this.productgroupColl) {
      if (pbo.productColl.length > 0) {
        var sabo = {
          groupid: pbo.groupid,
          groupname: pbo.groupname,
        }
        this.groupColl.push(sabo)
      }
    }



    if (this.productgroupColl.length > 0) {
      this.selectgroup = this.productgroupColl[0].groupname
    }

  }



  fnGroupBtnClick(groupname) {
    this.selectgroup = groupname;

    let el = document.getElementById(groupname);
    el.scrollIntoView({ block: "start", inline: "nearest", });
  }

  fnGroupToggleBtnClick(groupname) {
    this.selectgroup = groupname;

    let el = document.getElementById(groupname);
    //  el.scrollIntoView({ block: "start", inline: "nearest" });



    var pos = el.style.position;
    var top = el.style.top;
    el.style.position = 'relative';
    el.style.top = '-100px';
    //el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    el.scrollIntoView({ block: "start", inline: "nearest" });
    el.style.top = top;
    el.style.position = pos;

    this.isshowcategory = !this.isshowcategory

  }


  fnProductClick(abo) {

    var deptid = abo.productid

    this.modalRef = this.productFindService.open(QrproductdetailsComponent, { size: <any>'m', backdrop: 'static' });
    this.modalRef.componentInstance.productid = deptid
    this.modalRef.componentInstance.productBO = abo
    this.modalRef.componentInstance.variationColl = this.fnGetProductVariration(deptid)
    this.modalRef.componentInstance.selectvariationid = this.fnGetProductVarirationId(deptid)
    this.modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    });

    this.modalRef.componentInstance.cartchangeData.subscribe((receivedEntry) => {

      if (receivedEntry.action === "INCRESE") {
        this.fnProductIncrementBtnClick(receivedEntry.abo, "")
      }
      else if (receivedEntry.action === "DECRESE") {
        this.fnProductDecrementBtnClick(receivedEntry.abo, "")
      }
      else if (receivedEntry.action === "REMOVE") {
        this.fnProductRemoveBtnClick(receivedEntry.abo)
      }
      else if (receivedEntry.action === "ADD") {
        this.fnAddProductBtnClick(receivedEntry.abo, "")
      }
      // alert()
    })
  }


  fnSearchClick() {
    this.isopensearch = !this.isopensearch
  }

  fnGetProductVariration(productid) {

    var aColl = []

    for (let abo of this.productvariationColl) {
      if (abo.productid === productid) {
        aColl.push(abo)
      }
    }

    return aColl;

  }


  fnGetProductVarirationId(productid) {

    var variaionid = 0

    for (let abo of this.productvariationColl) {
      if (abo.productid === productid) {
        variaionid = abo.sizeid
        return variaionid
      }
    }

    return variaionid;

  }


  //Product
  fnAddProductBtnClick(prodBO, mode) {
    if (mode === "DIRECT" && prodBO.isvariation === 1) {
      this.fnProductClick(prodBO)
      return;
    }

    var data = {
      'companyid': this.companyBO.companyid,
      'dinetype': this.dinetype,
      'tableno': this.tblname,
      'productid': prodBO.productid,
      'qty': 1,
      'variationid': prodBO.variationid,
    }

    this.fnShowProcess()
    this.cartservice.fnInsertCartProduct(data)
      .subscribe(
        (res) => {
          this.fnHideProcess()
          if (res.json().status == 200) {



            const index = this.productColl.findIndex(a => a.productid === prodBO.productid);
            if (index > -1) {
              this.productColl[index].quantity = 1;
            }
            this.cartservice.fnGetCartList();



          }
          else if (res.json().status == 400) {
            this.fnShowErrorMsg('Error' + res.json().err_field);
          }
        },
        (err) => {
          this.fnHideProcess()
          this.fnShowErrorMsg('Error' + err);
        })

  }

  fnProductIncrementBtnClick(prodBO, mode) {
    if (mode === "DIRECT" && prodBO.isvariation === 1) {
      this.fnProductClick(prodBO)
      return;
    }

    var data = {
      'companyid': this.companyBO.companyid,
      'dinetype': this.dinetype,
      'tableno': this.tblname,
      'productid': prodBO.productid,
      'qty': prodBO.quantity + 1,
      'variationid': prodBO.variationid,
    }

    console.log(data)
    this.fnShowProcess()

    this.cartservice.fnInsertCartProduct(data)
      .subscribe(
        (res) => {
          this.fnHideProcess()
          if (res.json().status == 200) {

            const index = this.productColl.findIndex(a => a.productid === prodBO.productid);
            if (index > -1) {
              this.productColl[index].quantity = prodBO.quantity + 1;
            }
            this.cartservice.fnGetCartList();
          }
          else if (res.json().status == 400) {
            this.fnShowErrorMsg('Error' + res.json().err_field);
          }
        },
        (err) => {
          this.fnHideProcess()
          this.fnShowErrorMsg('Error' + err);
        })
  }

  fnProductDecrementBtnClick(prodBO, mode) {

    if (mode === "DIRECT" && prodBO.isvariation === 1) {
      this.fnProductClick(prodBO)
      return;
    }

    var data = {
      'dinetype': this.dinetype,
      'companyid': this.companyBO.companyid,
      'tableno': this.tblname,
      'productid': prodBO.productid,
      'qty': prodBO.quantity - 1,
      'variationid': prodBO.variationid,
    }
    this.fnShowProcess()
    this.cartservice.fnInsertCartProduct(data)
      .subscribe(
        (res) => {
          this.fnHideProcess()
          if (res.json().status == 200) {

            const index = this.productColl.findIndex(a => a.productid === prodBO.productid && a.productid === prodBO.productid);
            if (index > -1) {
              this.productColl[index].qty = prodBO.qty - 1;
            }
            this.cartservice.fnGetCartList();
          }
          else if (res.json().status == 400) {
            this.fnShowErrorMsg('Error' + res.json().err_field);
          }
        },
        (err) => {
          this.fnHideProcess()
          this.fnShowErrorMsg('Error' + err);
        })
  }

  fnProductRemoveBtnClick(prodBO) {
    var data = {
      'dinetype': this.dinetype,
      'companyid': this.companyBO.companyid,
      'tableno': this.tblname,
      'productid': prodBO.productid,
      'qty': 0,
      'variationid': prodBO.variationid,
    }

    this.cartservice.fnInsertCartProduct(data)
      .subscribe(
        (res) => {
          if (res.json().status == 200) {

            const index = this.productColl.findIndex(a => a.productid === prodBO.productid && a.productid === prodBO.productid);
            if (index > -1) {
              this.productColl[index].qty = prodBO.qty - 1;
            }
            this.cartservice.fnGetCartList();
          }
          else if (res.json().status == 400) {
            this.fnShowErrorMsg('Error' + res.json().err_field);
          }
        },
        (err) => {
          this.fnShowErrorMsg('Error' + err);
        })
  }

  fnUpdateCartChange() {
    for (let wbo of this.productColl) {
      const index = this.cartColl.findIndex(a => a.productid === wbo.productid);
      if (index > -1) {
        wbo.quantity = this.cartColl[index].quantity;
      } else {
        wbo.quantity = 0;
      }
    }


    //console.log( this.cartColl)

    this.fnReloadProductList();

  }


  fnRequestBtnClick() {

    this.modalRef = this.productFindService.open(RequestComponent, { size: <any>'m', backdrop: 'static' });
    this.modalRef.componentInstance.dinetype = this.dinetype
    this.modalRef.componentInstance.tableno = this.tblname
    this.modalRef.componentInstance.companyid = this.companyBO.companyid
    this.modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    });

  }


  //Check Out
  fnCheckoutBtnClick() {

    this.modalRef = this.productFindService.open(CartsliderComponent, { size: <any>'m', backdrop: 'static' });
    this.modalRef.componentInstance.companyid = this.companyBO.companyid;
    this.modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      console.log(receivedEntry)
      this.fnSetCartPlaced(receivedEntry);
    });

    this.modalRef.componentInstance.cartchangeData.subscribe((receivedEntry) => {

      if (receivedEntry.action === "ADD") {
        this.fnProductIncrementBtnClick(receivedEntry.abo, "")
      }
      else if (receivedEntry.action === "DECRESE") {
        this.fnProductDecrementBtnClick(receivedEntry.abo, "")
      }
      else if (receivedEntry.action === "REMOVE") {
        this.fnProductRemoveBtnClick(receivedEntry.abo)
      }
      // alert()
    })
  }


  fnSetCartPlaced(receivedEntry) {
    var data = {
      'customername': receivedEntry.customername,
      'mobile': receivedEntry.mobile,
      'remarks': receivedEntry.remarks,
      'companyid': this.companyBO.companyid,
      'houseno': receivedEntry.houseno,
      'street': receivedEntry.street,
      'address': receivedEntry.address,
      'pincode': receivedEntry.pincode,
      'areacity': receivedEntry.areacity
    }

    this.cartservice.fnSetCartPlaced(data)
      .subscribe(
        (res) => {
          if (res.json().status == 200) {
            console.log(res.json().result)



            this.cartservice.fnGetCartList();
            var result = res.json().result
            console.log(result)
            var cartid = 0;
            if (result.length > 0) {
              cartid = result[0].cartid
            }
            this.fnShowOrderStatus(receivedEntry.mobile, cartid)
          }
          else if (res.json().status == 400) {
            this.fnShowErrorMsg('Error' + res.json().err_field);
          }
        },
        (err) => {
          this.fnShowErrorMsg('Error' + err);
        })
  }

  fnShowOrderStatus(mobile, cartid) {

    this.modalRef = this.productFindService.open(OrderstatusComponent, { size: <any>'m', backdrop: 'static' });
    this.modalRef.componentInstance.mobileno = mobile
    this.modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === "VIEWORDER") {
        this.fnOpenOrderDetilsPopUp(cartid)
      }
    });
  }


  fnOpenOrderDetilsPopUp(cartid) {
    this.modalRef1 = this.productFindService.open(OrdersdetailsComponent, {
      size: 'lg', backdropClass: 'light-blue-backdrop', centered: true
    });
    this.modalRef1.componentInstance.cartid = cartid;
    this.modalRef1.componentInstance.fnGetOrderDetails()

  }



  //LOGIn


  //Signup login
  fnSignupLoginBtnClick(type) {
    const modalRef = this.productFindService.open(LoginComponent, {
      size: 'lg', backdropClass: 'light-blue-backdrop', centered: true, backdrop: 'static',
      keyboard: false
    });
    if (type === "LOGIN") {
      modalRef.componentInstance.islogin = true;
    } else if (type === "SIGNUP") {
      modalRef.componentInstance.issignup = true;
    }
    modalRef.componentInstance.companyid = this.companyBO.companyid
    modalRef.componentInstance.emitData.subscribe((loginEntry) => {

      this.fnGetLoginCustomer(loginEntry)

    });

  }
  fnGetLoginCustomer(data) {


    localStorage.setItem('adtoken', JSON.stringify(data));
    this.loginService.fnGetCustomerList();
    this.fnSetCartLoginCustomer();
    window.location.reload();


    // this.loginservice.fnGetCustomerLogin(data)
    // .subscribe(
    //   (res)=>{                  
    //   if(res.json().status==200){                            

    //    let _customerid=res.json().result[0].customerid;       
    //    localStorage.setItem('token', JSON.stringify(_customerid));
    //    this.loginservice.fnGetCustomerList();
    //     this.fnSetCartLoginCustomer();
    //   }
    //   else if(res.json().status==400){                          
    //     this.fnShowErrorMsg('Error'+res.json().err_field);
    //   }

    // },
    // (err)=>{          
    //   this.fnShowErrorMsg('Error'+ err);
    // })

  }
  async fnSetCartLoginCustomer() {
    var data = {
      'customerid': 0,
      'sessionid': ''
    }
    await this.loginService.fnSetCartCustomerLogin(data).then(
      (res) => {
        if (res.json().status == 200) {
          this.cartservice.fnGetCartList();
        }
        else if (res.json().status == 400) {
          this.fnShowErrorMsg('Error' + res.json().err_field);
        }

      },
      (err) => {
        this.fnShowErrorMsg('Error' + err);
      })

  }

  //Logout
  fnLogoutBtnClick() {
    localStorage.removeItem('adtoken');
    this.loginService.fnGetCustomerList();
    this.router.navigate(['/']);
    window.location.reload();
  }

  //Manage Orders
  fnManageOrdersBtnClick() {
    this.modalRef = this.productFindService.open(OrdersComponent, {
      size: 'lg', backdropClass: 'light-blue-backdrop', centered: true
    });
    this.modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry.doctype === "VIEWORDER") {
        this.fnOpenOrderDetilsPopUp(receivedEntry.cartid)
      }
    });
  }

fnSelectGroup(name: string) {
    this.selectedGroupName = name;

    if (name === 'All') {
        const container = document.querySelector('.emenumain');
        if (container) {
            container.scrollTo({ top: 0, behavior: 'smooth' });
        }
    } else {
        const el = document.getElementById(name);
        const container = document.querySelector('.emenumain');

        if (el && container) {
           
            const headerOffset = 180;
            const elementPosition = el.offsetTop;
            const offsetPosition = elementPosition - headerOffset;

            container.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }
}
  // @HostListener('window:beforeunload')
  // canDeactivate(): any {

  //   let body = document.getElementsByTagName('body')[0];
  //   if (body.classList.length > 0) {
  //     if (body.classList[0] === 'modal-open') {
  //       console.log('return false')
  //       return false;
  //     }
  //   }
  //   else{    
  //     return true;
  //   }


  // }


  private fnShowProcess() {
    this.isload = true;
  }
  private fnHideProcess() {
    this.isload = false;
  }

  fnShowErrorMsg(ex) {
    console.log(ex)
  }

}